// creates a copy of an es6 class instance
export const cloneInstanceClass = instanceClass => Object
  .assign(Object.create(Object.getPrototypeOf(instanceClass)), instanceClass)
